import React from 'react'
import Button from '../Button/Button'

const FormFile = ({
  id,
  name,
  className,
  placeholder,
  disabled,
  value,
  onChange,
  checked,
  readOnly,
  filename,
  icon,
  iconPos,
  size,
  accept,
  variant = 'default',
}) => {
  return (
    <div
      className={
        'formfile' +
        (disabled ? ' formfile--disabled' : '') +
        (size ? ' formfile--' + size : ' formfile--md') +
        (className ? ' ' + className : '')
      }
    >
      <label className={`formfile__input-wrap`}>
        <input
          checked={checked}
          name={name}
          id={id}
          value={value}
          className="formfile__input"
          type="file"
          disabled={disabled}
          onChange={onChange}
          readOnly={readOnly}
          accept={accept}
        />
        <span className={`formfile__content ${variant === 'button' ? 'formfile__content--button' : ''}`}>
          {icon && iconPos === 'left' && <span className="formfile__icon">{icon}</span>}
          {filename ? (
            <span className="formfile__filename">{filename}</span>
          ) : (
            <>
              {variant === 'default' && <span className="formfile__label">{placeholder ? placeholder : ''}</span>}
              {variant === 'button' && <Button label={placeholder} icon={icon} icon_pos={'left'} variant={'primary'} className="formfile__button"/>}
            </>
          )}
          {icon && variant === 'default' && iconPos !== 'left' && <span className="formfile__icon">{icon}</span>}
        </span>

      </label>
    </div>
  )
}

export default FormFile
